import { IssueTypeFieldValuesAttachmentService as OvermapIssueTypeFieldValuesAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeFieldValuesAttachmentService extends OvermapIssueTypeFieldValuesAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
